
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('circle',{attrs:{"cx":"8","cy":"8","r":"8","fill":"currentColor"}}),_c('path',{attrs:{"fill":"#F7FCFF","d":"M14.3951 9.04902c-.2535-.22989-.6488-.21485-.9152 0l-1.9852 1.58768c-.2427.1955-.5457.3008-.8593.3008H8.09376c-.18906 0-.34375-.1547-.34375-.3438 0-.189.15469-.3437.34375-.3437h1.68223c.34161 0 .65961-.2342.71541-.57149.0709-.42969-.2599-.80352-.67888-.80352H6.37501c-.58008 0-1.14082.19981-1.592.56504l-.99902.80997H2.59375c-.18906 0-.34375.1547-.34375.3437v2.0625c0 .1891.15469.3438.34375.3438h7.66565c.3115 0 .6144-.1053.8594-.3008l3.2484-2.5996c.3266-.25996.3524-.7584.0279-1.05058zM8.00787 3.54688h-.51565V2.51564c0-.14822.07146-.27493.15597-.3595C7.73269 2.07158 7.85941 2 8.00774 2h.85954c.14834 0 .27505.07158.35956.15614.08451.08457.15596.21128.15596.3595v1.03124H8.00787zM7.49222 4.0625v.36595c-.13156.08285-.28296.20022-.41636.34696-.18459.20304-.3571.48789-.3571.8341v2.578h3.43754v-2.578c0-.34621-.17255-.63106-.35713-.8341-.13341-.14674-.28481-.26411-.41637-.34696V4.0625H7.49222z"}})])
          )
        }
      }
    